import { createSelector } from '@reduxjs/toolkit';

import { hasAllRequiredDocs } from '@/shared/utils/hasAllRequiredDocs';

import { getUploadedDocsForMyDriver } from './selectors';
import { driverUploadSelectors } from './upload-slice';

const getHasRequiredMyDriverDocs = createSelector(
  getUploadedDocsForMyDriver,
  driverUploadSelectors.getDocDefinitions,
  hasAllRequiredDocs,
);

export { getHasRequiredMyDriverDocs };
